import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-subscribe',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './subscribe.component.html',
  styleUrl: './subscribe.component.scss',
})
export class SubscribeComponent {
  email: string = '';
  emailError: string | null = null;
  successMessage: string | null = null;


  onMailchimpSubmit(event: Event) {
    event.preventDefault();
    
    if (!this.email) {
      this.successMessage = '';
      this.emailError = 'E-posta alanı zorunludur.';
      this.clearMessagesAfterDelay();
      return;
    }

    if (!this.validateEmail(this.email)) {
      this.successMessage = '';
      this.emailError = 'Geçerli bir e-posta adresi giriniz.';
      this.clearMessagesAfterDelay();
      return;
    }

    this.emailError = null;
    this.successMessage = '';

    const form = document.getElementById('mc-embedded-subscribe-form') as HTMLFormElement;

    const formData = new FormData(form);
    
    fetch(form.action, {
      method: 'POST',
      body: formData,
      mode: 'no-cors' // This is important for cross-origin requests
    })
    .then(() => {
      this.email = '';
      this.successMessage = 'Abonelik işlemi başarı ile gerçekleşti!';
      this.emailError = null;
      this.clearMessagesAfterDelay();
      
      // Clear any Mailchimp error messages
      const errorResponse = document.getElementById('mce-error-response');
      const successResponse = document.getElementById('mce-success-response');
      if (errorResponse) errorResponse.style.display = 'none';
      if (successResponse) successResponse.style.display = 'none';
    })
    .catch((error) => {
      console.error('Mailchimp error:', error);
      this.emailError = 'Abone olunamadı! Lütfen tekrar deneyiniz.';
      this.successMessage = '';
      this.clearMessagesAfterDelay();
    });
  }

  // E-posta adresi doğrulama fonksiyonu
  validateEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  }

  // Mesajları 3 saniye sonra temizle
  private clearMessagesAfterDelay() {
    setTimeout(() => {
      this.emailError = null;
      this.successMessage = null;
    }, 3000);
  }
}
